import common from 'common';
import httpRequest from './httpUtils';
/* httpRequest方法 默认post请求
 * post 请求 参数名称 data
 * get  请求 参数名称 params
 * */
function getAPIList(success, fail) {
  let data = {
    version: common.version,
    https: 1,
  };
  httpRequest({
    code: '100000',
    data,
    success: function (res, ok) {
      if (!ok) return;
      let apiListUrl = {
        800004: res.kejianSound.fileUrl,
      };
      res.apiList.forEach((k, i) => {
        apiListUrl[k.name] = k.url;
      });
      common.API = apiListUrl;
      common.set('apiListUrl', apiListUrl);
      common.set('isHeaderVersion', res.ignoreHeaderIds);
      // if(LIMI_ENV==="electron"){
      //   utils.setNodeStorge("domainList",res.domainList);
      // }
      success(res);
    },
    fail: fail,
  });
}
/**
 * 输入手机号码登陆
 * @param  phone 用户手机号码
 * @param success 成功回调函数
 */
function login(data, success) {
  httpRequest({ code: '100104', data, success });
}
//获取可切换环境列表
function getEnvList(success, fail) {
  const data = {
    platform: 'student',
  };
  httpRequest({ code: '100001', data, success, fail });
}
//小动物登陆
function animalLogin(data, success, fail) {
  httpRequest({ code: '100105', data, success, fail });
}
//获取课程列表
function getLessonList(data, success, fail) {
  httpRequest({ code: '300231', data, success, fail });
}
//获取体验课列表
function getExperienceLessonList(data, success, fail) {
  httpRequest({ code: '300230', data, success, fail });
}
//获取快速问答
function quickQuestion(params, success) {
  let method = 'get';
  httpRequest({ code: '400005', method, params, success });
}

//标准问答
function standardQuestion(params, success) {
  let method = 'get';
  httpRequest({ code: '400006', params, method, success });
}
//体验课标准问答
function standardQuestionExp(params, success) {
  let method = 'get';
  httpRequest({ code: '400025', params, method, success });
}
//回放页获取标准问答
function standardQuestionPlayBack(params, success) {
  let method = 'get';
  httpRequest({ code: '400028', params, method, success });
}
//我的班
function getClassList(data, success, fail, config) {
  httpRequest({ code: '300179', data, success, fail, config });
}
//获取资源文件
function getZip(data, success) {
  httpRequest({ code: '300118', data, success });
}
//轮训代替长连接
function getMsgClient(params, success) {
  let method = 'get';
  httpRequest({ code: '300117', params, method, success });
}
//API进课消息
function lessonIn(data, success, fail) {
  httpRequest({ code: '300119', data, success, fail });
}
//补发长连接消息
function sendSocketData(data, success, fail) {
  httpRequest({ code: '300110', data, success, fail });
}
//获取当前登录学生获取的徽章或者同小班的同学获取的徽章
//注：获取同小班同学徽章时需传小班ID以及同学ID
function usercenterBadgeList(data, success, fail) {
  httpRequest({ code: '300163', data, success, fail });
}
//修改用户头像
function modifyPhoto(data, success) {
  httpRequest({ code: '100115', data, success });
}
//获取默认头像列表
function getDefaultPhotoList(data, success) {
  httpRequest({ code: '300127', data, success });
}
//获取要上课的lesson的状态
function getLessonsState(data, success) {
  httpRequest({ code: '300185', data, success });
}
//退课
function lessonOut(data, success) {
  httpRequest({ code: '300129', data, success });
}
// 退课-录播
function recordLessonOut(data, success) {
  httpRequest({ code: '400035', data, success });
}
//获取所有课件题json
function getKejianJson(data, success) {
  httpRequest({ code: '300130', data, success });
}
//获取徽章信息
function getBadgeInVideo(params, success, fail) {
  let method = 'get';
  httpRequest({ code: '300136', method, params, success, fail });
}
//评论提交
function commitComment(data, success, fail) {
  httpRequest({ code: '300209', data, success, fail });
}
//获取拉流地址接口
function getPullUrl(data, success, fail) {
  httpRequest({ code: '300183', data, success, fail });
}
//获取发题记录
function getSendLog(data, success, fail) {
  httpRequest({ code: '300142', data, success, fail });
}
//获取发题记录-录播课
function getSendLogForRecord(data, success, fail) {
  httpRequest({ code: '400034', data, success, fail });
}
//获取发题记录
function getPlaybackSendLog(data, success, fail) {
  httpRequest({ code: '300201', data, success, fail });
}
//门店虚拟体验课答题API
function expAnswerQuestion(data, success, fail) {
  httpRequest({ code: '300135', data, success, fail });
}
//检查更新
function getLatestVersion(params, success, fail) {
  httpRequest({ code: '400008', method: 'get', params, success, fail });
}

//课前测答案上报
function sendPreQuestion(data, success, fail) {
  httpRequest({ code: '300143', method: 'Post', data, success, fail });
}
//课中排行榜
function getAnswerRank(data, success, fail) {
  httpRequest({ code: '300171', data, success, fail });
}
//课中排行榜
function getBadgeRank(data, success, fail) {
  httpRequest({ code: '300173', data, success, fail });
}
//班级列表页面基础数据（公告、个人信息、小游戏）
function getClassPageBaseData(data, success, fail, config) {
  httpRequest({ code: '300200', data, success, fail, config });
}
//首页徽章上报
function uploadBadge(data, success, fail) {
  httpRequest({ code: '300146', data, success, fail });
}
//获取长连接灾备地址
function getLivemsgAddr(data, success, fail) {
  httpRequest({ code: '300154', data, success, fail });
}
//获取服务器时间
function getServerTime(data, success, fail) {
  httpRequest({ code: '400012', data, success, fail });
}
function getMsgList(data, success, fail, config) {
  //消息列表查询
  httpRequest({ code: '300199', method: 'post', data, success, fail, config });
}
function getMsgDetail(data, success, fail) {
  //消息列表查询
  httpRequest({ code: '300159', method: 'post', data, success, fail });
}
function delMessage(data, success) {
  //消息列表查询
  httpRequest({ code: '300160', method: 'post', data, success });
}
//问题反馈
function problemFeedback(data, success, fail) {
  httpRequest({ code: '300161', method: 'post', data, success, fail });
}
//问题反馈类型
function getBugTyptList(params, success) {
  httpRequest({ code: '300164', method: 'get', params, success });
}
//获取ossToken
function getOssToken(params, success, fail) {
  httpRequest({ code: '300165', method: 'get', params, success, fail });
}
//oss上传语音成功
function uploadOssSuccess(data, success, fail) {
  httpRequest({ code: '300167', data, success, fail });
}
//直接跳转直播页面
function getTeacherLessonInfo(data, success, fail) {
  httpRequest({ code: '300170', method: 'post', data, success, fail });
}
//语音连麦上报异常
function uplodeTelephoneError(data, success, fail) {
  httpRequest({ code: '300174', method: 'post', data, success, fail });
}
//获取礼物列表
function getImageResources(data, success, fail) {
  httpRequest({ code: '300176', method: 'post', data, success, fail });
}
//直播回放持续观看时间上报
function durationRport(data, success, fail) {
  httpRequest({ code: '900002', method: 'post', data, success, fail });
}
//表扬数据
function getPraiseInfo(data, success, fail) {
  httpRequest({ code: '300178', data, success, fail });
}
//礼物礼物补发
function apiSendGift(data, success, fail) {
  httpRequest({ code: '300177', data, success, fail });
}
// 获取验证码
function getCode(data, success, fail) {
  httpRequest({ code: '100106', data, success, fail });
}
// 重置密码
function resetPwd(data, success, fail) {
  httpRequest({ code: '100107', data, success, fail });
}
// 无需验证码重置密码
function resetPwdNoVc(data, success, fail) {
  httpRequest({ code: '100111', data, success, fail });
}
// 校验验证码
function regCode(data, success, fail) {
  httpRequest({ code: '100108', data, success, fail });
}
// 验证码登录
function verifyCodeLogin(data, success, fail) {
  httpRequest({ code: '100109', data, success, fail });
}
// 设置弹幕字体颜色接口
function setFontColor(data, success, fail) {
  httpRequest({ code: '300186', data, success, fail });
}
//pk补发接口
function sendPkData(data, success, fail) {
  httpRequest({ code: '300189', data, success, fail });
}
//课后练习首页
function exerciseIndex(data, success, fail) {
  httpRequest({ code: '300202', data, success, fail });
}
//清除课后练习数据
function clearExercise(data, success, fail) {
  httpRequest({ code: '400030', data, success, fail });
}
//课后练习保存每道题答题信息
function exerciseQuestionSave(data, success, fail) {
  httpRequest({ code: '300203', data, success, fail });
}
//课后练习答题卡提交
function exerciseSubmit(data, success, fail) {
  httpRequest({ code: '300204', data, success, fail });
}
//课后练习订正
function exerciseCorrect(data, success, fail) {
  httpRequest({ code: '300205', data, success, fail });
}
// 获取快速问答选择题样式
function getXuanZeStyle(data, success, fail) {
  httpRequest({ code: '300206', data, success, fail });
}
// 获取头饰列表
function getHeadwearList(data, success, fail) {
  httpRequest({ code: '400026', data, success, fail });
}
function updateHeadwear(data, success, fail) {
  httpRequest({ code: '400027', data, success, fail });
}
export default {
  getAPIList,
  login,
  getLessonList,
  animalLogin,
  quickQuestion,
  standardQuestion,
  standardQuestionExp,
  standardQuestionPlayBack,
  getClassList,
  getMsgClient,
  lessonIn,
  sendSocketData,
  usercenterBadgeList,
  getZip,
  modifyPhoto,
  getDefaultPhotoList,
  getLessonsState,
  lessonOut,
  recordLessonOut,
  getKejianJson,
  getEnvList,
  commitComment,
  getBadgeInVideo,
  getPullUrl,
  getSendLog,
  getSendLogForRecord,
  expAnswerQuestion,
  getLatestVersion,
  sendPreQuestion,
  getAnswerRank,
  getBadgeRank,
  getClassPageBaseData,
  uploadBadge,
  getLivemsgAddr,
  getServerTime,
  getMsgList,
  getMsgDetail,
  delMessage,
  problemFeedback,
  getBugTyptList,
  getOssToken,
  uploadOssSuccess,
  getTeacherLessonInfo,
  uplodeTelephoneError,
  getImageResources,
  durationRport,
  getPraiseInfo,
  apiSendGift,
  getCode,
  resetPwd,
  resetPwdNoVc,
  regCode,
  setFontColor,
  sendPkData,
  verifyCodeLogin,
  getPlaybackSendLog,
  exerciseIndex,
  clearExercise,
  exerciseQuestionSave,
  exerciseSubmit,
  exerciseCorrect,
  getXuanZeStyle,
  getExperienceLessonList,
  getHeadwearList,
  updateHeadwear,
};



// WEBPACK FOOTER //
// ./src/js/liSrv.js